<template>
    <div class="row mt-5">
        <div class="col-12 mb-5">
            <label class="form-label" for="slots">
                {{ $trans.get('__JSON__.Add or Revoke shifts') }}
            </label>
<!--            <label class="form-label" for="slots" v-if="isAdmin">-->
<!--                {{ $trans.get('__JSON__.Add or Revoke shifts') }}-->
<!--            </label>-->
<!--            <label class="form-label" for="slots" v-else>-->
<!--                {{ $trans.get('__JSON__.Add extra shifts') }}-->
<!--            </label>-->
            <div class="input-group">
                <button type="button" class="btn btn-warning" @click="--slots" :disabled="slots <= minSlots">
                    <i class="bi bi-clipboard2-minus"></i>
                </button>
                <input id="slots" type="number" class="form-control" :min="minSlots" pattern="\d*" v-model="slots">
                <span class="invalid-feedback" role="alert" v-if="errors['slots']">
                    <strong>{{ errors['slots'][0] }}</strong>
                </span>
                <button type="button" class="btn btn-success" @click="++slots">
                    <i class="bi bi-clipboard2-plus"></i>
                </button>
            </div>
        </div>
        <div class="col-12 mb-5">
            <label class="form-label" for="reason">
                {{ $trans.get('__JSON__.Reason') }}
            </label>
            <textarea id="reason" cols="30" rows="5" class="form-control" v-model="reason"></textarea>
        </div>
    </div>
</template>

<script>
import ModalHelper from '../mixins/ModalHelper'
import RequestHandler from '../mixins/RequestHandler'
import ScheduleHelpers from '../mixins/ScheduleHelpers'

export default {
    name: 'AddOrRevoke',
    props: {
        department: {
            type: Object,
            required: true,
        },
        shift: {
            type: Object,
            required: true,
        },
        user: {
            type: Object,
            required: true,
        },
    },
    mixins: [ModalHelper, RequestHandler, ScheduleHelpers],
    computed: {
        minSlots() {
            return -Math.abs(this.shift.details.slots.left)
            // if (this.isAdmin) return -Math.abs(this.shift.details.slots.left)
            // return 1
        },
    },
    data() {
        return {
            disabled: false,
            confirmed: false,
            slots: 0,
            reason: null,
        }
    },
    watch: {
        disabled() {
            this.$parent.$data.disableSave = this.disabled
        },
        slots() {
            this.checkSave()
        },
        confirmed() {
            this.checkSave()
        },
    },
    methods: {
        save() {
            // only for admins ask to confirm to make sure they would like to subtract
            if (this.slots < 0) {
                this.confirmModal('shift_details_modal', [
                    {
                        label: this.$trans.get('__JSON__.Update all future shifts'),
                        variant: 'outline-danger',
                        onClick: async () => {
                            this.submit(this.shift.parent_id, this.shift.id)
                            await this.closeConfirm('shift_details_modal')
                        }
                    },
                    {
                        label: this.$trans.get('__JSON__.Update this shift only'),
                        variant: 'danger',
                        onClick: async () => {
                            this.submit(this.shift.id)
                            await this.closeConfirm('shift_details_modal')
                        }
                    },
                ])

                return
            }

            // ask what to update if we are having future shifts
            if (this.shift.has_future_shifts) {
                this.confirmModal('shift_details_modal', [
                    {
                        label: this.$trans.get('__JSON__.Update all future shifts'),
                        variant: 'outline-primary',
                        onClick: async () => {
                            this.submit(this.shift.parent_id, this.shift.id)
                            await this.closeConfirm('shift_details_modal')
                        }
                    },
                    {
                        label: this.$trans.get('__JSON__.Update this shift only'),
                        variant: 'primary',
                        onClick: async () => {
                            this.submit(this.shift.id)
                            await this.closeConfirm('shift_details_modal')
                        }
                    },
                ], this.$trans.get('__JSON__.Add or Revoke shifts'), this.$trans.get("__JSON__.Make a choice if you'd like to update only this shift or all future shifts as well. Any differences made from this point in time will get the amount of shifts on top of it."))

                return
            }

            // otherwise just update the single one
            this.submit(this.shift.id)
        },
        submit(shiftId, pointer = null) {
            this.disabled = true
            this.makeRequest('post', `/api/shifts/${shiftId}/mutate`, {
                action: (this.slots < 0) ? 'revoke' : 'extra',
                slots: this.slots,
                reason: this.reason,
                confirmed: this.confirmed,
                pointer,
            }, response => {
                this.$parent.stopEditing()
            }, error => {
                // on purpose
            }, () => this.disabled = false)
        },
        checkSave() {
            if (this.slots > 0) this.disabled = false
            else if (this.slots < 0 && ! this.isAdminOrManager) this.disabled = true
            else this.disabled = this.slots === 0
        },
    },
    mounted() {
        this.disabled = true
    },
    beforeUnmount() {
        this.disabled = true
    },
}
</script>
